// src/app/guards/auth.guard.ts
import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const authGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (authService.isAuthenticated()) {
    return true; // El usuario está logueado, permite el acceso.
  }

  // El usuario no está logueado, guarda la URL y redirige a login.
  authService.redirectUrl = state.url;
  return router.createUrlTree(['/auth/login']);
};
